export default {
	'no-data-to-show': 'No data to display.',
	'material-name': 'Material Name',
	'customer-name': 'Customer Name',
	'customer-type': 'Customer Type',
	date: 'Date',
	price: 'Price',
	quantity: 'Quantity',
	'payment-method': 'Payment Method',
	unknown: 'Unknown',
}
